import { Slider } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import styled from 'styled-components';

const ProgressSlider = styled(Slider)`
  color: ${(props) => props.color};
  height: 10px;
  min-width: 60%;
  width: 90%;
  .MuiSlider-thumb {
    height: ${(props) => props.thumb?.height || '20px'};
    width: ${(props) => props.thumb?.width || '30px'};
    background-color: #fff;
    border: 2px solid currentColor;
    border-radius: 20%;
    margin-top: -5px;
    margin-left: -12px;
    &:focus, &:hover, &$active: {
      box-shadow: inherit;
    }
  }
  .MuiSlider-valueLabel {
    left: calc(-50% + 8px);
  }
  .MuiSlider-rail {
    background-color: #dadada;
    height: 10px;
    border-radius: 5px;
  }
  .MuiSlider-mark {
    display: none;
  }
  .MuiSlider-track {
    height: 10px;
    border-radius: 5px;
  }
`;

const ProgressSlider1 = withStyles({
  root: {
    color: (props) => props.color,
    height: 10,
    minWidth: '60%',
    width: '90%',
    '&:hover, &:focus': {
      thumb: {
        visibility: 'visible',
      },
    },
  },
  thumb: {
    height: (props) => props.thumb?.height || 20,
    width: (props) => props.thumb?.width || 30,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    borderRadius: '20%',
    marginTop: -5,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
    visibility: 'hidden',
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 8px)',
  },
  track: {
    height: 10,
    borderRadius: 5,
  },
  rail: {
    backgroundColor: '#DADADA',
    height: 10,
    borderRadius: 5,
  },
  mark: {
    display: 'none',
  },
})(Slider);

export default ProgressSlider;
